import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import firebase from '../firebase-config';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const isChatPage = location.pathname === '/chat';

  useEffect(() => {
    const unsubscribe = firebase.auth.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
      setIsLoading(false);
      
      // We'll let App.js handle the body class for chat pages
    });

    return () => {
      unsubscribe();
      // We're removing the class management from here to avoid conflicts
    };
  }, [isChatPage]);

  if (isLoading) {
    return (
      <div className="loading-compact">
        <div className="loading-spinner"></div>
        <div>Connecting...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login...');
    return <Navigate to="/login" />;
  }

  const subscription = JSON.parse(localStorage.getItem('userSubscription'));
  console.log('Protected Route - Current subscription:', subscription);

  // Return the children directly without any wrapper divs that could interfere with layout
  return children;
};

export default ProtectedRoute; 